module.exports = __webpack_public_path__ + "img/a7.d90e243d.jpg";